import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function NumOneIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1ZM16.1221 6.99902L15.7168 7.50293C15.4472 7.85533 14.9903 8.23322 14.3447 8.63477C13.6992 9.02816 12.9918 9.28174 12.2236 9.39648L11.5 12.79H14.2588L11.9297 23.8701C11.8474 24.261 12.1473 24.6287 12.5488 24.6289H17.4209L21.0557 7.37891C21.0968 7.18343 20.9468 6.99925 20.7461 6.99902H16.1221Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
